import * as Lucide from "lucide-react";

export const Icon = ({ name, ...props }) => {
  const C = Lucide[name] || Lucide.Circle;
  return <C strokeWidth={1.5} {...props} />;
};
